import {Component, HostBinding, Input} from '@angular/core';

@Component({
    selector: 'vui-data-grid-context-table',
    templateUrl: './data-grid-context-table.component.html',
    styleUrls: ['./data-grid-context-table.component.scss']
})
export class DataGridContextTableComponent {
    @HostBinding('class.loaded') public _loaded: boolean;

    constructor() {

    }

    @Input()
    public set loaded(loaded) {
        setTimeout(() => {
            this._loaded = loaded;
        }, 500);
    }
}
